import styled from "styled-components";
import { colors } from "@streeteasy/design-system";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";

import { mapPin } from "../../assets";

const { GRAY, GRAY_LIGHT, GRAY_LIGHTEST, TEXT_PRIMARY, WHITE } = colors;

export const Trigger = styled.button.attrs({
  type: "button"
})`
  align-items: center;
  background-color: ${WHITE};
  border: 1px solid ${GRAY};
  display: flex;
  font-size: 14px;
  font-weight: 400;
  height: 40px;
  padding: 0 8px;
  text-align: left;
  transition-duration: 0.3s;
  transition-property: background-color, border-color, color;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  width: 100%;

  &:hover {
    border-color: ${GRAY_LIGHT};
  }

  &:focus {
    outline: 1px solid ${TEXT_PRIMARY};
    outline-offset: 2px;
  }

  &:active {
    background-color: ${GRAY_LIGHTEST};
    border-color: ${GRAY_LIGHTEST};
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    height: 45px;
  }
`;

export const MapPinIcon = styled.i.attrs({
  role: "presentation"
})`
  background-image: url(${mapPin});
  background-repeat: no-repeat;
  display: inline-block;
  height: 14px;
  margin-right: 8px;
  width: 9px;
`;
